/**
 * SCH-4 (K50) — when a manual board move requires an operator-chosen reason.
 *
 * Governance applies to genuine CROSS-TECH manual reassignments (moving a
 * ticket from one technician to a different one) — that is exactly the
 * override the MoveReasonDialog captures, and the reason it yields feeds the
 * server preference-learning signal (`isPreferenceSignalReason` in
 * reassignCore). Same-tech time reorders and parked→tech assignments are
 * routine and are committed with a non-learning operational reason instead of
 * the former hardcoded `'drag-drop'` placeholder (which was never a real
 * learning signal).
 *
 * Pure + unit-tested. No React, no I/O.
 */
import type { MoveReason } from '@/lib/moveReasonConstants';

/** Operational reason for routine (non-override) manual moves. */
export const DEFAULT_OPERATIONAL_MOVE_REASON: MoveReason = 'other';

/**
 * True when a manual move is a cross-technician reassignment and therefore
 * should capture an operator override reason before committing.
 */
export function manualMoveRequiresReason(
  oldTechId: string | null | undefined,
  newTechId: string | null | undefined,
): boolean {
  return !!oldTechId && !!newTechId && oldTechId !== newTechId;
}
